export abstract class Generico {
    id: number;
    nomeResponsavelModificacao: string;
    dataCriacao: Date;
    dataModificacao: Date;
    responsavelCriacao: string;
    responsavelModificacao: string;
    geolocalizacao: string;
    ativo: boolean;
    ip: string;
    nomeResponsavelCriacao: string;

    constructor(data?) {
        if(data){
            this.id = data.id;
            this.dataCriacao = new Date(data.dataCriacao);
            this.dataModificacao = data.dataModificacao ? new Date(data.dataModificacao) : null;
            this.responsavelCriacao = data.responsavelCriacao;
            this.responsavelModificacao = data.responsavelModificacao;
            this.geolocalizacao = data.geolocalizacao;
            this.responsavelModificacao = data.responsavelModificacao;
            this.ativo = data.ativo;
            this.ip = data.ip;
        }
    }
}
